require('./ctxModal.style.scss');

class CtxModalController {
    constructor($element, $scope, $timeout, $window, $document, $filter, docsService, $attrs, $rootScope) {
        this.$element = $element;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$window = $window;
        this.$filter = $filter;
        this.docsService = docsService;
        this.$attrs = $attrs;
        this.$rootScope = $rootScope;
        this.modalClass = this.modalClass || 'modal-sm';
        this.defaultCloseTitle = this.$filter('translate')('common.form.default.btn.close.label');
        this.haveCloseBtn = this.haveCloseBtn || true;
        this.tooltipMsg = this.tooltipMsg || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
        this.$element.find('[data-toggle="tooltip"]').tooltip({ title: this.tooltipMsg });
        this.customKeyDownFn = (e) => {
            if (!this.showModal) return;
            // if (e.keyCode === 32) {
            //     e.stopImmediatePropagation();
            //     e.stopPropagation();
            //     e.preventDefault();
            // }
            if (e.keyCode === 27 && !this.disableInteraction) {
                // check if other dialog is open
                if (!!this.$document.find('.modal-open .ctx-dialog-service-template')[0] || (!this.isSubModal && !!this.$document.find('.modal-open .sub-ctx-modal')[0])) return;
                this.onUserClose();
            }
            if (e.keyCode === 13 && !this.disableInteraction) {
                let targetEl = $(e.target);
                if (targetEl && (targetEl.hasClass('ace_text-input') || targetEl.is('#inputSearchName'))) return;
                // check if other dialog is open
                if (!!this.$document.find('.modal-open .ctx-dialog-service-template')[0] || (!this.isSubModal && !!this.$document.find('.modal-open .sub-ctx-modal')[0])) return;
                this.actionButtons.filter(button => {
                    if ((button.type === 'submit' || button.title === 'Next') && !button.isDisabled() && (!button.isVisible || button.isVisible())) return button.action();
                });
            }
        };
        this.$document[0].addEventListener('keydown', this.customKeyDownFn, false);
        this.$rootScope.$on('closeModal', () => {
            if (this.showModal) {
                this.onOutsideClose();
            }
        });
    }

    $postLink() {
        this.$timeout(() => {
            let headerHeight, footerHeight;
            this.modal = this.$element.find('.modal');
            this.modalBody = this.modal.find('.modal-body');
            headerHeight = this.modal.find('.modal-header').outerHeight() || 50;
            footerHeight = this.modal.find('.modal-footer').outerHeight() || 50;
            this.heightDiff = headerHeight + footerHeight;
            this.defaultTop = 120;
            this.defaultBootom = 50;

            this.$scope.$watch(() => this.showModal, show => {
                if (show && this.preOpen) {
                    this.preOpen().then((res) => {
                        if (res) this.onShowModalChanged(show);
                        else this.showModal = false;
                    }, err => {
                        this.showModal = false;
                    });
                } else {
                    this.onShowModalChanged(show);
                }
            });
        });
    }

    onShowModalChanged(show) {
        if (typeof show === 'undefined') return;
        this.advancedSettings = false;
        if (show && this.fancyScroll) {
            this.modalBody.css({ 'height': 'auto', 'max-height': '0', 'overflow': 'hidden' });
        }
        let availableHeight = this.getAvailableHeight();
        if (show) {
            this.id = this.isJsonString(this.eventId) ? JSON.parse(this.eventId) : this.eventId;
            this.closeButtonTitle = this.id && this.id.closeTitle ? this.id.closeTitle : this.defaultCloseTitle;
            if (this.modalBody) {
                this.modalBody.css({ 'min-height': '' });
                this.modalBody.css({ 'max-height': availableHeight + 'px' });
            }
            this.onOpen ? this.onOpen() : false;
            //set focus
            if (!this.dontFocus) {
                this.modal.on('shown.bs.modal', () => {
                    this.$element.find('input').first().focus();
                });
            }

            this.$timeout(() => {
                if (this.isSubModal) {
                    this.subModalBackudrop = this.$document.find('.modal-backdrop:last-child ');
                    if (this.subModalBackudrop[0]) {
                        this.modal.css('z-index', 1052);
                        this.subModalBackudrop.css('z-index', 1051);
                    }
                }
            }, 500, false);
        }
        else {
            if (this.modalBody && this.modalBody[0]) {
                const height = this.modalBody[0].getBoundingClientRect().height || 0,
                    minHeight = parseInt(this.modalBody.css('min-height'), 10) || 0;
                this.modalBody.css({ 'min-height': (height > minHeight ? height : minHeight) + 'px' });
            }
            if (this.isSubModal) {
                this.modal.css('z-index', '');
                this.subModalBackudrop.css('z-index', '');
            }
            this.onClose && !this.onCloseHandled ? this.onClose() : false;
        }
        this.onCloseHandled = false;
        this.modal.modal(show ? { show: true, backdrop: 'static', keyboard: false } : 'hide');
        this.setResizeHandler(show, availableHeight);
    }

    setResizeHandler(show, availableHeight) {
        if (show) {
            let resizeEv, newAvailableHeight, fancyScrollMaxHeight;
            this.$window.onresize = () => {
                if (resizeEv) clearTimeout(resizeEv);
                resizeEv = setTimeout(() => {
                    if (this.modalBody && this.modalBody[0]) {
                        if (this.resizeCounter >= 0) {
                            this.resizeCounter++;
                        }
                        //console.log('MODAL => counter', this.resizeCounter)
                        newAvailableHeight = this.getAvailableHeight();
                        if (availableHeight !== newAvailableHeight) {
                            if (!this.fancyScroll) {
                                this.modalBody.css({ 'max-height': newAvailableHeight + 'px' });
                                return;
                            }
                            availableHeight = newAvailableHeight;
                            fancyScrollMaxHeight = this.modalBody.find('.mCSB_container').height() + 42;
                            this.modalBody.animate({
                                'max-height': availableHeight,
                                'height': fancyScrollMaxHeight > availableHeight ? availableHeight : fancyScrollMaxHeight,
                            }, 150, "linear", () => {
                                this.modalBody.css({ 'height': 'auto' });
                            });
                        }
                    }
                }, 150);
            };
        } else {
            this.$window.onresize = undefined;
        }
    }

    getAvailableHeight() {
        let element = this.modal.find('.modal-dialog'),
            windowHeight = $(window).height(),
            windowAvailableHeight = windowHeight - this.defaultTop - this.defaultBootom - this.heightDiff,
            availableHeight = !this.maxHeight ? windowAvailableHeight : this.maxHeight,
            margin;

        if (!this.isSubModal && (!this.maxHeight || this.maxHeight <= windowAvailableHeight)) {
            element.css({ 'margin': this.defaultTop + 'px' + ' auto ' + this.defaultBootom + 'px auto', 'max-height': 'calc(100% - ' + (this.defaultTop + this.defaultBootom) + 'px)' });
            return availableHeight;
        }
        margin = (windowHeight - (this.maxHeight + this.heightDiff)) / 2;
        margin = margin >= 0 ? margin : 0;
        element.css({ 'margin': margin + 'px' + ' auto', 'max-height': 'calc(100% - ' + (2 * margin) + 'px)' });
        return availableHeight;
    }

    onUserHelp() {
        this.docsService.openHelp(this.helpId);
    }

    onUserClose() {
        if (this.onClose) {
            this.onClose();
        }
        if (this.isSubModal) {
            this.modal.css('z-index', '');
            this.subModalBackudrop.css('z-index', '');
        }
        this.onCloseHandled = true;
        this.showModal = false;
    }

    onOutsideClose() {
        if (this.onClose) {
            this.onClose();
        }
        if (this.isSubModal) {
            this.modal.css('z-index', '');
            this.subModalBackudrop.css('z-index', '');
        }
        this.showModal = false;
    }

    onTitleHandle() {
        if (this.onTitleClick) {
            this.onTitleClick();
        }
    }

    onShowAdvancedChanged() {
        if (this.onAdvancedShow) {
            this.advancedSettings = !this.advancedSettings;
            this.onAdvancedShow({ show: this.advancedSettings });
        }
    }

    $onDestroy() {
        if (this.modal) {
            this.modal.modal('hide');
        }
        this.$document[0].removeEventListener('keydown', this.customKeyDownFn, false);
    }

    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}

const ctxModalComponent = {
    restrict: 'E',
    transclude: true,
    controller: CtxModalController,
    controllerAs: 'modalCtrl',
    template: require('./ctxModal.template.html'),
    bindings: {
        showModal: '=',
        eventId: '@?',
        onClose: '&?',
        onOpen: '&?',
        preOpen: '&?',
        onTitleClick: '&?',
        modalTitle: '<',
        modalSubTitle: '<?',
        actionButtons: '<',
        modalClass: '@?',
        aboutClass: '@?',
        haveCloseBtn: '<?',
        about: '<?',
        busy: '<?',
        tooltipMsg: '<?',
        helpId: '@?',
        fancyScroll: '<?',
        maxHeight: '<?',
        showAdvancedSettings: '<?',
        advancedLabel: '@?',
        advancedId: '@?',
        onAdvancedShow: '&?',
        disableInteraction: '<?',
        dontFocus: '<?',
        resizeCounter: '=?',
        isSubModal: '<?'
    }
};

CtxModalController.$inject = ['$element', '$scope', '$timeout', '$window', '$document', '$filter', 'docsService', '$attrs', '$rootScope'];

module.exports = ctxModalComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxModal/ctxModal.component.js